import "@fontsource/inter";
import CssBaseline from "@mui/joy/CssBaseline";
import {
  CssVarsProvider as JoyCssVarsProvider,
  StyledEngineProvider,
} from "@mui/joy/styles";
import {
  THEME_ID as MATERIAL_THEME_ID,
  Experimental_CssVarsProvider as MaterialCssVarsProvider,
  experimental_extendTheme as materialExtendTheme,
} from "@mui/material/styles";
import {
  Navigate,
  Outlet,
  RouterProvider,
  createBrowserRouter,
  useLocation,
  useParams,
  useSearchParams,
} from "react-router-dom";

import { theme } from "./components/Theme";
import ForgotPassword from "./pages/ForgotPassword/ForgotPassword";
import Verified from "./pages/Verified";
import Verify from "./pages/Verify/Verify";
// import Home from "./pages/Home";
import { Box, Stack } from "@mui/joy";
import BreadcrumbHeader from "./components/BreadcrumbHeader";
import NavSidebar from "./components/NavSidebar/NavSidebar";
import ProtectedRoute from "./components/ProtectedRoute";
import BusinessContact from "./pages/BusinessContact/v2/BusinessContact";
import Carts from "./pages/Carts/Carts";
import Catalogues from "./pages/Catalogues";
import Credit from "./pages/Credit/Credit";
import Dashboard from "./pages/Dashboard/Dashboard";
import { AddEmployee } from "./pages/Employee/AddEmployee";
import Employee from "./pages/Employee/Employee";
import UpdateEmployee from "./pages/Employee/UpdateEmployee";
import ForgotPasswordVerify from "./pages/ForgotPasswordVerify/ForgotPasswordVerify";
import ListInventory from "./pages/Inventory/ListInventory";
import Item from "./pages/Item";
import ListSupplierItems from "./pages/Items/ListSupplierItems";
import Manage from "./pages/Manage";
import NotFound from "./pages/NotFound/NotFound";
import Notis from "./pages/Notis";
import EditOrders from "./pages/Order/EditOrders";
// import EditOrders from "./pages/Order/EditOrdersV2";
// import ListOrders from "./pages/Order/ListOrders";
import AddBusinessContact from "./pages/BusinessContact/v2/AddBusinessContact";
import { EditBusinessContact } from "./pages/BusinessContact/v2/EditBusinessContact";
import ListCatalogue from "./pages/Catalogues/ListCatalogue";
import EditInventory from "./pages/Inventory/EditInventory";
import KYC from "./pages/KYC/KYC";
import ListOrders from "./pages/Order/ListOrders";
// import ListOrders from "./pages/Order/ListOrdersV2";
import PhoneVerified from "./pages/PhoneVerified/PhoneVerified";
import { CreateBusiness } from "./pages/Profile/Business/CreateBusiness";
import UpdateBusiness from "./pages/Profile/Business/UpdateBusiness";
import MobileOtpVerification from "./pages/Profile/MobileOtpVerification";
import ProfileChangePassword from "./pages/Profile/ProfileChangePassword";
import ProfileFullName from "./pages/Profile/ProfileFullName";
import ProfileMobileNumber from "./pages/Profile/ProfileMobileNumber";
import Profiles from "./pages/Profile/Profiles";
import SetPassword from "./pages/SetPassword/SetPassword";
import Signin from "./pages/Signin/Signin";
import Signup from "./pages/Signup/Signup";
import SignupSSO from "./pages/SignupSSO/SignupSSO";
import ListSuppliers from "./pages/Suppliers/ListSuppliers";
import TermsAndCondition from "./pages/TermsAndCondition/TermsAndCondition";
import Welcome from "./pages/Welcome";
import {
  getActiveBusiness,
  mixpanelProfilePayload,
  useAuthStore,
} from "./store/session";
import { BrowserRouterConstants } from "./utils/constants";
import { getBreadcumb } from "./utils/navbar";

import { useEffect, useRef, useState } from "react";
import PublicCarts from "./pages/Carts/PublicCarts";
import ManageCatalogueItems from "./pages/Inventory/ManageCatalogueItems";
import ListCatalogueItems from "./pages/Items/ListCatalogueItems";

import KycSnackBar from "./components/kyc/KycSnackBar";
import { BusinessSessionHelper } from "./helpers/business-session.helper";
import CartCheckout from "./pages/Carts/CartCheckout";
import CatalogueDuplicateSKU from "./pages/Catalogues/CatalogueDuplicateSKU";
import CreateCatalogue from "./pages/Catalogues/CreateCatalogue";
import EditCatalogue from "./pages/Catalogues/EditCatalogue";
import ExportImportCatalogue from "./pages/Catalogues/ExportImportCatalogue";
import AddCatalogueItems from "./pages/Inventory/AddCatalogueItems";
import BatchEditInventory from "./pages/Inventory/BatchEditInventory";
import ExportImportInventory from "./pages/Inventory/ExportImportInventory";
import InventoryDuplicateSKU from "./pages/Inventory/InventoryDuplicateSKU";
import ItemDetail from "./pages/Items/ListCatalogueItemDetail";
import SupplierItemDetail from "./pages/Items/SupplierItemDetail";
import PublicViewListOutstandingOrders from "./pages/Order/PublicViewListOutstandingOrders";
import PublicViewOrder from "./pages/Order/PublicViewOrder";
import ReportOrders from "./pages/Order/ReportOrders";
import PaymentLink from "./pages/PaymentLink";
import PhoneInput from "./pages/PhoneInput/PhoneInput";
import { AddressList } from "./pages/Profile/Address/AddressList";
import ProfileKYC from "./pages/Profile/KYC";
import Referrals from "./pages/Referral/Referrals";
import SignupCompanyProfile from "./pages/SignupCompanyProfile/SignupCompanyProfile";
import { TrackerService } from "./services/tracker.service";

import BatchUpdateAddItems from "./pages/Inventory/components/BatchUpdateAddItems";
import BatchEditCatalogueItems from "./pages/Items/BatchEditCatalogueItems";
import BatchUpdateAddCatalogItems from "./pages/Items/components/BatchUpdateAddItems";
import ListOutstandingOrders from "./pages/Order/ListOutstandingOrders";
import LandingPage from "./pages/Finance/BNPL/Landing";

import UpdatePersonalProfile from "./pages/Profile/Personal/UpdatePersonalProfile";
import Upgrade from "./pages/Upgrade/Upgrade";
import UpgradeForm from "./pages/Upgrade/UpgradeForm";
import PublicCartCheckout from "./pages/Carts/PublicCartCheckout";
import ShareCatalogue from "./pages/Catalogues/ShareCatalogue";

const PanelLayout = () => {
  const { session } = useAuthStore();
  const isAuthenticated = session !== null;
  const { pathname } = useLocation();
  const [searchParams] = useSearchParams();
  const mode = searchParams.get("mode");

  const breadcumb = getBreadcumb(pathname, mode ?? null);
  const isDashboardRoute = ["/client", "/client/"].includes(pathname);

  const scrollBoxRef = useRef<HTMLDivElement>(null);
  const [isScrollDown, setIsScrollDown] = useState(false);

  const business = getActiveBusiness();
  const buyerAccountAllowedRoutes = [
    "suppliers",
    "orders",
    "profile",
    "referrals",
    "cart",
    "upgrade-account",
    "finance",
  ];
  const buyerAccountExcliveRoutes = ["upgrade"];
  if (business && business.businessAccountType === "BUYER") {
    const isAllowed = buyerAccountAllowedRoutes.find((route) =>
      pathname.includes(route)
    );

    if (isAllowed === "orders" && pathname.includes("reports")) {
      window.location.href = "/client/suppliers";
    }

    if (!isAllowed) {
      window.location.href = "/client/suppliers";
    }
  } else {
    const isNotAllowed = buyerAccountExcliveRoutes.find((route) =>
      pathname.includes(route)
    );

    if (isNotAllowed) {
      window.location.href = "/client/";
    }
  }

  return (
    <Box
      className="flex"
      sx={{
        height: "100dvh",
        transition: "300ms",
      }}
    >
      {/* Sidebar */}
      <Box overflow="hidden" maxWidth={{ xs: "0", lg: "240px" }}>
        <NavSidebar />
      </Box>

      {/* Main Content */}
      <Box
        ref={scrollBoxRef}
        onScroll={() => {
          if (scrollBoxRef.current && scrollBoxRef.current.scrollTop > 50) {
            setIsScrollDown(true);
          } else {
            setIsScrollDown(false);
          }
        }}
        maxWidth={{ xs: "100%", lg: "calc(100% - 240px)" }}
        minWidth={{ xs: "100%", lg: "0" }}
        width={"100%"}
        height={"100%"}
        sx={{ overflowY: "scroll" }}
      >
        {/* Main Content - Header */}
        <Box
          position={"sticky"}
          top={0}
          zIndex={50}
          py={2}
          bgcolor={"var(--joy-palette-common-white)"}
          pb={0}
        >
          <Stack px={{ xs: "16px", md: "24px" }}>
            <BreadcrumbHeader paths={breadcumb} />
          </Stack>
          {/* <Headers /> */}
        </Box>

        {/* Main Content - Body */}
        <Box pb={0}>
          {!(
            window.location.href.endsWith("/profile") ||
            window.location.href.endsWith("/profile/kyc")
          ) &&
            !BusinessSessionHelper.IsValidatedKYCPaymentGateway() &&
            session?.activeBusiness.businessAccountType !== "BUYER" && (
              <Box
                bgcolor={
                  isDashboardRoute
                    ? "var(--joy-palette-others-list_item_border)"
                    : ""
                }
                pb={"8px"}
              >
                <Stack px={{ xs: "16px", md: "24px" }}>
                  <KycSnackBar />
                </Stack>
              </Box>
            )}
          <ProtectedRoute redirectRoute="/signin" isValid={isAuthenticated}>
            <ProtectedRoute
              redirectRoute="/kyc"
              isValid={
                !!session?.isKYCComplete ||
                session?.activeBusiness.businessAccountType === "BUYER"
              }
            >
              <Stack
                px={{ xs: "16px", md: "24px" }}
                bgcolor={
                  isDashboardRoute ||
                  pathname.startsWith("/client/business-contact/update")
                    ? "var(--joy-palette-others-list_item_border)"
                    : ""
                }
              >
                <Outlet context={{ isScrollDown }} />
              </Stack>
            </ProtectedRoute>
          </ProtectedRoute>
        </Box>
      </Box>
      {/* <Footer /> */}
    </Box>
  );
};

const PublicLayout = () => {
  const scrollBoxRef = useRef<HTMLDivElement>(null);
  const [isScrollDown, setIsScrollDown] = useState(false);
  return (
    <Box
      ref={scrollBoxRef}
      onScroll={() => {
        if (scrollBoxRef.current && scrollBoxRef.current.scrollTop > 50) {
          console.log("scrolled", scrollBoxRef.current.scrollTop);
          setIsScrollDown(true);
        } else {
          setIsScrollDown(false);
        }
      }}
      paddingX={"24px"}
    >
      <Outlet context={{ isScrollDown }} />
    </Box>
  );
};

// handle the redirection for `/catalog/:catalogId/items`
const RedirectCatalogToPublic = () => {
  const { catalogId } = useParams();
  return <Navigate to={`/public/suppliers/${catalogId}/items`} replace />;
};

const browserRouter = () => {
  const { session } = useAuthStore();
  const isAuthenticated = session !== null;

  return createBrowserRouter([
    {
      path: "/",
      element: <Welcome />,
      errorElement: <NotFound />,
    },
    {
      path: "/kyc",
      element: (
        <ProtectedRoute
          redirectRoute="/client"
          isValid={
            isAuthenticated &&
            !session?.isKYCComplete &&
            session.activeBusiness.businessAccountType !== "BUYER"
          }
        >
          <KYC />
        </ProtectedRoute>
      ),
      errorElement: <NotFound />,
    },
    {
      path: "/terms-and-condition",
      element: <TermsAndCondition />,
    },
    {
      path: "/online-payment/:linkId",
      element: <PaymentLink />,
    },
    {
      path: "/catalog/:catalogId/items",
      element: <RedirectCatalogToPublic />,
    },
    {
      path: "/public/suppliers/:catalogId/items",
      element: <ListSupplierItems />,
    },
    {
      path: `/public/${BrowserRouterConstants.SupplierItem}`,
      element: <SupplierItemDetail />,
    },
    {
      path: "/public/cart/:catalogId/items",
      element: <PublicCarts />,
    },
    {
      path: `/public/${BrowserRouterConstants.CartItemsCheckout}`,
      element: <PublicCartCheckout />,
    },
    {
      path: "/full-view/inventory",
      element: <ListInventory />,
    },
    {
      path: "/full-view/inventory/:inventoryItemId/edit",
      element: <EditInventory />,
    },
    {
      path: "/public/",
      element: <PublicLayout />,
      children: [
        {
          path: "orders/:orderType/:orderId",
          element: <PublicViewOrder />,
        },
      ],
    },
    {
      path: "/public/orders/outstanding/",
      element: <PublicViewListOutstandingOrders />,
    },
    {
      path: BrowserRouterConstants.ClientPrefix,
      element: <PanelLayout />,
      children: [
        { index: true, element: <Dashboard /> },
        // { index: true, element: <ComingSoon /> },
        // {
        //   path: BrowserRouterConstants.CataloguesItems,
        //   element: <Items />,
        // },
        {
          path: BrowserRouterConstants.UpgradeAccount,
          element: <Upgrade />,
        },
        {
          path: BrowserRouterConstants.UpgradeAccountForm,
          element: <UpgradeForm />,
        },
        {
          path: BrowserRouterConstants.Credit,
          element: <Credit />,
        },
        {
          path: BrowserRouterConstants.Referrals,
          element: <Referrals />,
        },
        {
          path: BrowserRouterConstants.Catalogues,
          element: <Catalogues />,
        },
        {
          path: BrowserRouterConstants.Supplier,
          element: <ListSuppliers />,
        },
        {
          path: BrowserRouterConstants.SupplierItems,
          element: <ListSupplierItems />,
        },
        {
          path: BrowserRouterConstants.SupplierItem,
          element: <SupplierItemDetail />,
        },
        {
          path: BrowserRouterConstants.CartItems,
          element: <Carts />,
        },
        {
          path: BrowserRouterConstants.CartItemsCheckout,
          element: <CartCheckout />,
        },
        {
          path: BrowserRouterConstants.Inventory,
          element: <ListInventory />,
        },
        {
          path: BrowserRouterConstants.InventoryEdit,
          element: <EditInventory />,
        },
        {
          path: BrowserRouterConstants.InventoryExportImport,
          element: <ExportImportInventory />,
        },
        {
          path: BrowserRouterConstants.InventoryDuplicate,
          element: <InventoryDuplicateSKU />,
        },
        {
          path: BrowserRouterConstants.InventoryBatchEdit,
          element: <BatchEditInventory />,
        },
        {
          path: BrowserRouterConstants.addItemsToMassUpdate,
          element: <BatchUpdateAddItems />,
        },
        {
          path: BrowserRouterConstants.CataloguesList,
          element: <ListCatalogue />,
        },
        {
          path: BrowserRouterConstants.CataloguesCreate,
          element: <CreateCatalogue />,
        },
        {
          path: BrowserRouterConstants.CatalogueEdit,
          element: <EditCatalogue />,
        },
        {
          path: BrowserRouterConstants.AddCataloguesItems,
          element: <AddCatalogueItems />,
        },
        {
          path: BrowserRouterConstants.CatalogInventoryItems,
          element: <ListCatalogueItems />,
        },
        {
          path: BrowserRouterConstants.ShareCatalogue,
          element: <ShareCatalogue />,
        },
        {
          path: BrowserRouterConstants.CatalogBatchEditItems,
          element: <BatchEditCatalogueItems />,
        },
        {
          path: BrowserRouterConstants.CatalogAddItemsToMassUpdate,
          element: <BatchUpdateAddCatalogItems />,
        },
        {
          path: BrowserRouterConstants.CatalogInventoryItem,
          element: <ItemDetail />,
        },
        {
          path: BrowserRouterConstants.ManageCatalogInventoryItem,
          element: <ManageCatalogueItems />,
        },
        {
          path: BrowserRouterConstants.CatalogExportImport,
          element: <ExportImportCatalogue />,
        },
        {
          path: BrowserRouterConstants.CatalogCreateDuplicate,
          element: <CatalogueDuplicateSKU />,
        },
        {
          path: BrowserRouterConstants.CatalogImportDuplicate,
          element: <CatalogueDuplicateSKU />,
        },
        {
          path: BrowserRouterConstants.ItemDetails,
          element: <Item />,
        },
        {
          path: BrowserRouterConstants.Orders,
          element: <ListOrders />,
        },
        {
          path: BrowserRouterConstants.OutstandingOrders,
          element: <ListOutstandingOrders />,
        },
        {
          path: BrowserRouterConstants.ReportOrders,
          element: <ReportOrders />,
        },
        {
          path: BrowserRouterConstants.OrdersEdit,
          element: <EditOrders />,
        },
        {
          path: BrowserRouterConstants.BizPayLaterLink,
          element: <LandingPage />,
        },
        {
          path: BrowserRouterConstants.Notis,
          element: <Notis />,
        },
        {
          path: BrowserRouterConstants.Profile,
          element: <Profiles />,
        },
        {
          path: BrowserRouterConstants.ProfileFullName,
          element: <ProfileFullName />,
        },
        {
          path: BrowserRouterConstants.ProfileMobileNumber,
          element: <ProfileMobileNumber />,
        },
        {
          path: BrowserRouterConstants.ProfileMobileNumberVerification,
          element: <MobileOtpVerification />,
        },
        {
          path: BrowserRouterConstants.ProfileChangePassword,
          element: <ProfileChangePassword />,
        },
        {
          path: BrowserRouterConstants.ProfileBusiness,
          element: <CreateBusiness />,
        },
        {
          path: BrowserRouterConstants.ProfileBusinessUpdate,
          element: <UpdateBusiness />,
        },
        {
          path: BrowserRouterConstants.ProfilePersonalUpdate,
          element: <UpdatePersonalProfile />,
        },
        {
          path: BrowserRouterConstants.ProfileAddress,
          element: <AddressList />,
        },
        {
          path: BrowserRouterConstants.Employees,
          element: <Employee />,
        },
        {
          path: BrowserRouterConstants.AddEmployee,
          element: <AddEmployee />,
        },
        {
          path: BrowserRouterConstants.UpdateEmployee,
          element: <UpdateEmployee />,
        },
        {
          path: BrowserRouterConstants.BusinessContact,
          element: <BusinessContact />,
        },
        {
          path: BrowserRouterConstants.AddBusinessContact,
          element: <AddBusinessContact />,
        },
        {
          path: BrowserRouterConstants.UpdateBusinessContact,
          element: <EditBusinessContact />,
        },
        {
          path: BrowserRouterConstants.Manage,
          element: <Manage />,
        },
        {
          path: BrowserRouterConstants.ProfileKYC,
          element: <ProfileKYC />,
        },
      ],
    },
    {
      path: BrowserRouterConstants.Signup,
      element: (
        <ProtectedRoute isValid={!isAuthenticated}>
          <Signup />
        </ProtectedRoute>
      ),
    },
    {
      path: `${BrowserRouterConstants.Signup}/phone-input`,
      element: <PhoneInput />,
    },
    {
      path: BrowserRouterConstants.SignupSSO,
      element: <SignupSSO />,
    },
    {
      path: `${BrowserRouterConstants.Signup}/company-profile`,
      element: <SignupCompanyProfile />,
    },
    {
      path: BrowserRouterConstants.Verify,
      element: <Verify />,
    },
    {
      path: BrowserRouterConstants.PasswordResetVerify,
      element: <ForgotPasswordVerify />,
    },
    {
      path: BrowserRouterConstants.Signin,
      element: (
        <ProtectedRoute isValid={!isAuthenticated}>
          <Signin />
        </ProtectedRoute>
      ),
    },
    {
      path: BrowserRouterConstants.Recover,
      element: <ForgotPassword />,
    },
    {
      path: BrowserRouterConstants.SetPassword,
      element: <SetPassword />,
    },
    {
      path: BrowserRouterConstants.Verified,
      element: <Verified />,
    },
    {
      path: BrowserRouterConstants.PhoneVerified,
      element: <PhoneVerified />,
    },
  ]);
};

export default function App() {
  const { session } = useAuthStore();
  const isAuthenticated = session !== null;
  isAuthenticated &&
    TrackerService.identify(
      session?.account.email || "",
      mixpanelProfilePayload(session)
    );

  useEffect(() => {
    const handleStorageChange = (event: StorageEvent) => {
      if (event.key === "userSession") {
        const storedSession = localStorage.getItem("userSession");
        if (storedSession) {
          if (JSON.parse(storedSession).state.session === null) {
            window.location.href = "/signin";
          }
        } else {
          window.location.href = "/signin";
        }
      }
    };

    window.addEventListener("storage", handleStorageChange);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, []);

  /**
   * This is dirty code. It's kind of like extending the MUI theme with Joy UI theme.
   * Necessary for MUI-X components (eg. date-picker)
   */
  const materialTheme = materialExtendTheme({
    colorSchemes: {
      light: {
        palette: {
          common: {
            black: "#101828",
            white: "#FFF",
          },
          primary: {
            50: "#F1F8F4",
            100: "#DDEEE3",
            200: "#BDDDCA",
            300: "#91C4A9",
            400: "#62A583",
            500: "#499873",
            600: "#2F6C51",
            700: "#265641",
            800: "#204536",
            900: "#1B392D",
          },
          success: {
            50: "#f0fdf4",
            100: "#dcfce7",
            200: "#bbf7d0",
            300: "#86efac",
            400: "#4ade80",
            500: "#22c55e",
            600: "#16a34a",
            700: "#15803d",
            800: "#166534",
            900: "#14532d",
          },
          warning: {
            50: "#FEFAF6",
            100: "#FDF0E1",
            200: "#FCE1C2",
            300: "#F3C896",
            400: "#EA9A3E",
            500: "#9A5B13",
            600: "#72430D",
            700: "#492B08",
            800: "#2E1B05",
            900: "#1D1002",
          },
          text: {
            secondary: "#555E68",
          },
        },
      },
      dark: {
        palette: {
          common: {
            black: "#000",
            white: "#FFF",
          },
          primary: {
            50: "#F1F8F4",
            100: "#DDEEE3",
            200: "#BDDDCA",
            300: "#91C4A9",
            400: "#62A583",
            500: "#499873",
            600: "#2F6C51",
            700: "#265641",
            800: "#204536",
            900: "#1B392D",
          },
          success: {
            50: "#f0fdf4",
            100: "#dcfce7",
            200: "#bbf7d0",
            300: "#86efac",
            400: "#4ade80",
            500: "#22c55e",
            600: "#16a34a",
            700: "#15803d",
            800: "#166534",
            900: "#14532d",
          },
          warning: {
            50: "#fff7ed",
            100: "#ffedd5",
            200: "#fed7aa",
            300: "#fdba74",
            400: "#fb923c",
            500: "#f97316",
            600: "#ea580c",
            700: "#c2410c",
            800: "#9a3412",
            900: "#7c2d12",
          },
          text: {
            secondary: "#555E68",
          },
        },
      },
    },
  });
  return (
    <MaterialCssVarsProvider theme={{ [MATERIAL_THEME_ID]: materialTheme }}>
      <StyledEngineProvider injectFirst>
        <JoyCssVarsProvider defaultMode="light" theme={theme}>
          <CssBaseline />
          <Box>
            <RouterProvider router={browserRouter()} />
          </Box>
          <div id="recaptcha-container" />
        </JoyCssVarsProvider>
      </StyledEngineProvider>
    </MaterialCssVarsProvider>
  );
}
